/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
// @ts-nocheck

import { Box, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import noDataImage from '../../assets/images/maintenance.svg'
import { selectSchool } from '../../helpers/selectors'

const MaintenanceServiceStatus = ({ children, metadata, school }) => {
  if (!metadata.on_maintenance) {
    return <>{children}</>
  }
  return (
    <>
      <Box width="100%" height="100%" p={{ xs: 4, sm: 8 }}>
        <Box textAlign="center">
          <img src={school.sch_logo} />
        </Box>

        <Box
          height="100%"
          pt={5}
          pb={5}
          align="center"
          display="flex"
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
        >
          <Typography component="h6" variant="h5" gutterBottom>
            <Box component="span" fontWeight="600" fontSize={28} className="text-primary">
              We are taking time out for maintenance.
            </Box>
          </Typography>
          <Typography component="h4" variant="h5" color="textPrimary" gutterBottom>
            <Box component="span" fontWeight="600" fontSize={28}>
              We will be back soon.
            </Box>
          </Typography>
          <Box textAlign="center" py={5} width={{ xs: '250px', sm: '450px', md: '500px' }}>
            <img width="100%" src={noDataImage} alt="no data" />
          </Box>

          <Typography component="h6" variant="body2" color="textSecondary" gutterBottom>
            <Box component="span" fontWeight="600" fontSize={16}>
              Meanwhile, you can contact us on
              <a
                className="link-color-text space-left1 space-right1"
                href="mailto:info@exceled.com"
              >
                {school.sch_pub_contact_email}
              </a>{' '}
              for your inquiries.
            </Box>
          </Typography>
        </Box>
      </Box>
    </>
  )
}

MaintenanceServiceStatus.propTypes = {
  children: PropTypes.element,
  metadata: PropTypes.object,
  school: PropTypes.object,
}

MaintenanceServiceStatus.defaultProps = {
  children: PropTypes.element,
  metadata: PropTypes.object,
  school: {},
}
const mapStateToProps = (state) => ({
  school: selectSchool(state),
})

/**
 *  @exports connect function of redux
 */
export default connect(mapStateToProps, {})(MaintenanceServiceStatus)
